export enum ErrorPageIcon {
  CatalogCollections = 'CatalogCollections',
  Catalogs = 'Catalogs',
  PageError = `PageError`,
  QueryBuilder = 'QueryBuilder',
}

export type ErrorPageProps = {
  /** Text for back link. */
  backText?: string;
  /** Pass in `to` url to show back link. */
  backTo?: string;
  /** Header text to display. */
  header?: string;
  /** Name of icon to display. See `core/errorPage/iconHelper.js` for list of icon names. */
  icon?: ErrorPageIcon;
};
